<script setup lang="ts">
  import AssistantHeader from "./AssistantHeader.vue";

  interface ConversationSummary {
    token: string;
    title: string;
  }

  withDefaults(
    defineProps<{
      open?: boolean;
      working?: boolean;
      conversationTitle?: string;
      conversations?: ConversationSummary[];
      currentConversationToken?: string | null;
    }>(),
    {
      open: false,
      working: false,
      conversationTitle: "New conversation",
      conversations: () => [],
      currentConversationToken: null,
    },
  );

  const emit = defineEmits(["close", "new", "select-conversation"]);
</script>

<template>
  <Transition
    enter-active-class="transition duration-[280ms] ease-[cubic-bezier(.2,.8,.2,1)]"
    enter-from-class="translate-x-6 opacity-0"
    leave-active-class="transition duration-200 ease-in"
    leave-to-class="translate-x-6 opacity-0">
    <!-- No backdrop: the page stays readable and usable behind the panel. -->
    <section
      v-if="open"
      role="dialog"
      aria-label="Episto AI"
      class="fixed bottom-5 right-5 top-[76px] z-50 flex w-[440px] flex-col overflow-hidden rounded-xl border border-border bg-card shadow-lg">
      <AssistantHeader
        :working="working"
        :conversation-title="conversationTitle"
        :conversations="conversations"
        :current-conversation-token="currentConversationToken"
        @close="emit('close')"
        @new="emit('new')"
        @select-conversation="(token: string) => emit('select-conversation', token)" />

      <div class="min-h-0 flex-1">
        <slot />
      </div>
    </section>
  </Transition>
</template>
